import { Component, ElementRef, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { fromEvent, Subscription } from 'rxjs';
import { TermoAceiteService } from 'src/app/core/services/termo-aceite.service';
import { TermoAceiteModel } from 'src/app/dominio/termo-aceite-model';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';

@Component({
  selector: 'app-termo-aceite-modal',
  templateUrl: './termo-aceite-modal.component.html',
  styleUrls: ['./termo-aceite-modal.component.scss']
})
export class TermoAceiteModalComponent implements OnInit, OnDestroy {

  public config: PerfectScrollbarConfigInterface = {};

  termos: TermoAceiteModel[] = [];
  usuarioTermo: string;
  termoAtual: TermoAceiteModel;
  termoIndexAtual = 0;
  titulo = 'Termo de Aceite';
  mostrarIndice = false;

  private scrollSubscription: Subscription;

  constructor(private dialogRef: MatDialogRef<TermoAceiteModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notificacaoService: NotificacaoService,
    private termoAceiteService: TermoAceiteService,
    private carregandoService: CarregandoService,
    private elementRef: ElementRef) {
    this.termos = data.termos;
    this.usuarioTermo = data.usuarioTermo;
  }

  ngOnInit() {

    if (this.termos.length > 1) {
      this.titulo = 'Termos de Aceite';
      this.mostrarIndice = true;
    }

    this.termoAtual = this.termos[this.termoIndexAtual];
    this.baixarArquivo(this.termoAtual);
  }

  baixarArquivo(termoAceite: TermoAceiteModel) {
    this.termoAceiteService.baixarArquivo(termoAceite.id).subscribe(arq => {
      termoAceite.blobArquivo = arq;

      const URL = window.URL;
      termoAceite.url = URL.createObjectURL(arq);

      termoAceite.carregado = true;
    }, (erro) => {
      this.notificacaoService.erro(erro);
    });
  }

  todosAceitos() {
    return !this.termos.some(p => !p.aceito);
  }

  fechar() {
    this.dialogRef.close();
  }

  async aceitar() {

    if (!this.termoAtual.aceito || !this.termoAtual.lido) {
      return;
    }

    try {
      this.carregandoService.mostra('aceitar');
      await this.termoAceiteService.aceitar(this.termoAtual.id, this.usuarioTermo).toPromise();

      this.destruirEventoScroll();

      if (this.termoIndexAtual + 1 === this.termos.length) {
        if (this.todosAceitos())
          this.dialogRef.close(true);
      } else {
        this.termoIndexAtual++;
        this.termoAtual = this.termos[this.termoIndexAtual];
        this.baixarArquivo(this.termoAtual);
      }

    } catch (erro) {
      this.notificacaoService.erro(erro);
    }
    finally {
      this.carregandoService.esconde('aceitar');
    }
  }

  vincularEventoScroll() {

    setTimeout(() => {

      if (this.termoAtual.rolagemObg) {
        const element = this.elementRef.nativeElement.querySelector('#viewerContainer');

        if (element.scrollHeight > element.clientHeight) {

          this.destruirEventoScroll();

          this.scrollSubscription = fromEvent(element, 'scroll').subscribe((event: Event) => {
            const target = event.target as HTMLElement;

            if (target.clientHeight + target.scrollTop >= target.scrollHeight - 25) {
              this.termoAtual.lido = true;
            }
          });
        } else {
          this.termoAtual.lido = true;
        }
      } else {
        this.termoAtual.lido = true;
      }

    }, 1);
  }

  destruirEventoScroll() {
    if (this.scrollSubscription) {
      this.scrollSubscription.unsubscribe();
    }
  }

  ngOnDestroy(): void {
    this.destruirEventoScroll();
  }
}
